import { getTopicOptions } from "../../services/dashboard";

/**
 *
 * @param {string} language Language "en" or "es"
 * @param {function} setTopicOptions Setter function for topics.
 * @param {function} setSubtopicOptions Setter function for subtopics.
 *
 * @returns Object with response from API
 */
export async function getTopicData(
  language,
  setTopicOptions,
  setSelectedTopic
) {
  try {
    const responseTopics = await getTopicOptions(true, language ?? "es");

    if (responseTopics === "ERROR_LOADING_DATA") return "ERROR_LOADING_DATA";

    const { data } = responseTopics;

    if (data) {
      if (setTopicOptions) setTopicOptions(data);
      if (setSelectedTopic) setSelectedTopic(data[0].code);

      return data;
    }
  } catch (error) {
    console.log("Error getting topic data");
    console.log("error", error);
  }
}
